import { Component, OnInit, Input, AfterViewInit } from '@angular/core'
import { CalenModel } from './calen.model'
import { DomSanitizer } from '@angular/platform-browser'
import { PageService } from '../../page/page.service'
import { CalenService } from './calen.service'
import { AjaxService } from 'src/app/shared/ajax.service'

@Component({
  selector: 'app-calen',
  templateUrl: './calen.component.html'
})
export class CalenComponent implements OnInit {
  @Input() model: CalenModel;

  constructor(private pservice: PageService, private service: CalenService, private sanitizer: DomSanitizer, private ajax: AjaxService) {
    service.components = pservice.components.calens
  }

  ngOnInit() {
    this.pservice.components.calens.push(this)
    this.model.shtm = this.sanitizer.bypassSecurityTrustHtml(this.model.htm)
  }

  ngAfterViewInit() {
    var thos = this
    var data

    this.ajax.execute({
      url: '',
      data: data,
      success: (post: any) => {

      }
    })
  }

}
